import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

// Import Material-UI
import { Checkbox, FormControlLabel, MenuItem, Select, TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';

// Import CSS
import "./VariableModal.css"

export function VariableModal({ setOpen, variables, dropdownValue, setDropdownValue, indexValue, setIndexValue, handleAddClick, setOpenVariable, include, exclude }) {
  const { t } = useTranslation();
  const [showIndexInput, setShowIndexInput] = useState(false);
  const [showIndexCheckbox, setShowIndexCheckbox] = useState(false);
  const [variableList, setVariableList] = useState(variables);

  useEffect(() => {
    let isInclude = false;
    if (include) {
      setVariableList(variables.filter((x) => include.includes(x.type)));
      isInclude = true;
    }
    else { setVariableList(variables); }
    if (exclude) { setVariableList(variables.filter((x) => !exclude.includes(x.type))); }
    else if (!isInclude) {
      setVariableList(variables);
    }
    if (dropdownValue?.type?.toLowerCase() === 'array') {
      setShowIndexCheckbox(true);
      setShowIndexInput(true);
      setIndexValue(0)
    }

  }, [variables, include, setVariableList, exclude, dropdownValue?.type])

  const handleVariableChange = (value) => {
    setDropdownValue(value);
    if (value.type === 'array') {
      setShowIndexCheckbox(true);
      setShowIndexInput(true);
    }
    else {
      setShowIndexInput(false);
      setShowIndexCheckbox(false);
    }
  }

  const handleIndexChange = (event) => {
    if (event.target.value >= 0) {
      setIndexValue(event.target.value);
    }
  }

  const handleClose = () => {
    setOpen(false);
  };

  const handleShowIndex = (event) => {
    if (event.target.checked) {
      setIndexValue(null);
    }
    setShowIndexInput((pre) => !pre)
  }

  return (
    <Dialog open={true} onClose={handleClose}>
      <DialogTitle id="alert-dialog-title">
        <div id="about-title">
          {t('CONTENT.CONFIGURATION-FORM.VARIABLES')}
        </div>
      </DialogTitle>
      <DialogContent style={{ width: 300 }}>
        <p className="modal-text">{t('CONTENT.AUTOMS-LIST.CHOOSE-VARIABLE')}</p>
        {/* <Select value={dropdownValue} onChange={handleVariableChange} variant="outlined" fullWidth style={{ marginBottom: 20 }} >
          {variableList?.length > 0 && JSON.stringify(variableList[0]) !== '{}' ? variableList.map((item, itemI) =>
            <MenuItem key={itemI} value={item}>{item.display_name ? item.display_name : item.name}</MenuItem>
          ) :
            <MenuItem button onClick={() => setOpenVariable({ type: "open", id: "" })} value="">{t('CONTENT.AUTOMS-LIST.ADD-NEW-VARIABLES')}</MenuItem>
          }
        </Select> */}
        <Autocomplete
          style={{ marginBottom: 20 }}
          onChange={(event, value, reason) => handleVariableChange(value ? value : "")}
          value={dropdownValue}
          id="variable-change-box"
          size="small"
          options={variableList?.length > 0 && JSON.stringify(variableList[0]) !== '{}' ? variableList : []}
          getOptionLabel={(item) => {
            if (item.name) {
              return item.display_name ? item.display_name : item.name
            }
            return item
          }}
          renderInput={(params) => <TextField {...params} variant="outlined" />}
        />
        {showIndexCheckbox &&
          <FormControlLabel
            className='show-index-checkbox'
            control={
              <Checkbox
                checked={!showIndexInput}
                onChange={handleShowIndex}
                name="showIndex"
                color="#C4C4C4"
                size="small"
              />
            }
            label={t('CONTENT.CONFIGURATION-FORM.SHOW-INDEX')} />
        }
        {showIndexInput &&
          <div className="index-input-container">
            <div>{t('CONTENT.CONFIGURATION-FORM.INDEX')}:</div>
            <TextField
              variant="outlined"
              onChange={handleIndexChange}
              value={indexValue} type="number"
            ></TextField>
          </div>
        }
      </DialogContent>
      <DialogActions className="modal-actions">
        <Button
          onClick={handleClose}
          variant="outlined"
          style={{ backgroundColor: "#BBBBBB", borderRadius: "2px", color: "#fff", width: "45%", border: "none" }}>
          {t('CONTENT.USER.CANCEL')}
        </Button>
        <Button
          onClick={handleAddClick}
          variant="outlined"
          style={{ backgroundColor: "#46474E", borderRadius: "2px", color: "#fff", width: "45%", border: "none" }}>
          {t('CONTENT.CONFIGURATION-FORM.ADD')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
